import { render, staticRenderFns } from "./SafeQty.vue?vue&type=template&id=0b05c964&"
import script from "./SafeQty.vue?vue&type=script&lang=js&"
export * from "./SafeQty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports